import React from "react";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Tab,
  Tabs,
  Grid,
  Divider,
  Typography,
  Avatar,
  Checkbox,
  Chip,
  Badge,
  Tooltip,
} from "@mui/material";
import { Padding, ThumbUpOutlined } from "@mui/icons-material";
import { useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { setErrorMessage } from "../../redux/actions/appActions";
import { dedupeJobApplicantRecords } from "../../utils/dedupeJobApplicants";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

// type Candidate = {
//   id: number;
//   name: string;
//   status?: "bestFit" | "declined";
//   unread?: boolean;
// };

type Candidate = {
  id: number;
  name: string;
  unread?: boolean;
  showDot?: boolean;   // <-- ✅ add this line
  status?: "bestFit" | "declined" | string;
  avatar?: string;
};


const candidates: Candidate[] = [
  { id: 1, name: "Karthike Sharma", unread: true },
  { id: 2, name: "Meenakshi Gulkarni", unread: true },
  { id: 3, name: "Meenakshi Gulkarni", unread: true, status: "bestFit" },
  { id: 4, name: "Meenakshi Gulkarni", status: "bestFit" },
  { id: 5, name: "Meenakshi Gulkarni" },
  { id: 6, name: "Meenakshi Gulkarni", status: "declined" },
  { id: 7, name: "Meenakshi Gulkarni", status: "declined" },
  { id: 8, name: "Meenakshi Gulkarni", status: "bestFit" },
  { id: 9, name: "Meenakshi Gulkarni", status: "declined" },
  { id: 10, name: "Meenakshi Gulkarni", status: "bestFit" },
  { id: 11, name: "Meenakshi Gulkarni", status: "declined" },
  { id: 12, name: "Meenakshi Gulkarni", status: "declined" },
];

const candidates2: Candidate[] = [
  { id: 1, name: "Karthike Sharma" },
  { id: 2, name: "Sophia Gulkarni", unread: true, showDot: true },
  { id: 3, name: "Emma Alice", unread: true, showDot: true },
  { id: 4, name: "Alex James", unread: false },
  { id: 5, name: "Meenakshi Gulkarni", status: "bestFit" },
];


function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && <Box sx={{ p: 0, width: "100%" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface ApplicantsProps {
  onCommentClick: () => void;
  onShareClick: () => void;
  onRecommendClick?: () => void;
  onSelectApplicant?: (item: any, details: any) => void;
  onCheckboxChange?: (selectedCandidates: any[]) => void;
  onTabChange?: (activeTab: number) => void;
  groupedApplicants?: {
    APPLIED: any[];
    SHORTLISTED: any[];
  };
  loading?: boolean;
  selectedApplicantId?: number | null;
  selectedCandidates?: any[];
  totalUnreadCommentCount?: number;
  hideSearch?: boolean;
  hideComment?: boolean;
  hideShare?: boolean;
  hideRecommend?: boolean;
  showSharedProfiles?: boolean;
  jobName?: string;
}

const Applicants = ({ onCommentClick, onShareClick, onRecommendClick, onSelectApplicant, onCheckboxChange, onTabChange, groupedApplicants, loading, selectedApplicantId, selectedCandidates, totalUnreadCommentCount, hideSearch = false, hideComment = false, hideShare = false, hideRecommend = true, showSharedProfiles = false, jobName }: ApplicantsProps) => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const [isCommentView, setIsCommentView] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");

  // Debug: Log the total unread comment count
  console.log('Total Unread Comment Count:', totalUnreadCommentCount);

  // Handle checkbox selection
  const handleCheckboxChange = (applicant: any, isChecked: boolean) => {
    if (!onCheckboxChange) return;
    
    let updatedSelectedCandidates = selectedCandidates || [];
    
    if (isChecked) {
      // Add to selection if not already selected
      if (!updatedSelectedCandidates.find(candidate => candidate.applicationId === applicant.applicationId)) {
        updatedSelectedCandidates = [...updatedSelectedCandidates, applicant];
      }
    } else {
      // Remove from selection
      updatedSelectedCandidates = updatedSelectedCandidates.filter(
        candidate => candidate.applicationId !== applicant.applicationId
      );
    }
    
    onCheckboxChange(updatedSelectedCandidates);
  };

  // Check if an applicant is selected
  const isApplicantSelected = (applicant: any) => {
    return selectedCandidates?.some(candidate => candidate.applicationId === applicant.applicationId) || false;
  };

  const dedupeApplicants = (list: any[] = []) => dedupeJobApplicantRecords(list);

  // Handle share click with validation
  const handleShareClick = () => {
    if (!selectedCandidates || selectedCandidates.length === 0) {
      dispatch(setErrorMessage("Please select at least one profile to share"));
      return;
    }
    // Call the original share click handler
    onShareClick();
  };

  // Filter applicants based on search term
  const filterApplicants = (applicants: any[]) => {
    if (!searchTerm.trim()) {
      return applicants;
    }
    
    return applicants.filter((applicant) => {
      const fullName = applicant.fullName?.toLowerCase() || "";
      const searchLower = searchTerm.toLowerCase();
      return fullName.includes(searchLower);
    });
  };

  // Get filtered applicants for each tab (with deduplication)
  const filteredAppliedApplicants = filterApplicants(dedupeApplicants(groupedApplicants?.APPLIED || []));
  const filteredShortlistedApplicants = filterApplicants(dedupeApplicants(groupedApplicants?.SHORTLISTED || []));
  // Shortlisted default to primary; only isPrimary === false goes to secondary
  const primaryShortlistedApplicants = useMemo(
    () => filteredShortlistedApplicants.filter(applicant => applicant.isPrimary !== false),
    [filteredShortlistedApplicants]
  );
  const secondaryShortlistedApplicants = useMemo(
    () => filteredShortlistedApplicants.filter(applicant => applicant.isPrimary === false),
    [filteredShortlistedApplicants]
  );
  
  // Combine all applicants for Shared Profiles view
  const allSharedProfiles = showSharedProfiles 
    ? filterApplicants(dedupeApplicants([...(groupedApplicants?.APPLIED || []), ...(groupedApplicants?.SHORTLISTED || [])]))
    : [];

  // Calculate the number of applicants with new comments
  const applicantsWithNewComments = useMemo(() => {
    const allApplicants = [...(groupedApplicants?.APPLIED || []), ...(groupedApplicants?.SHORTLISTED || [])];
    return allApplicants.filter(applicant => applicant.unreadCommentCount && applicant.unreadCommentCount > 0).length;
  }, [groupedApplicants]);
  // Debug logging for shortlisted applicants filtering
  console.log('Shortlisted applicants filtering:', {
    totalShortlisted: filteredShortlistedApplicants.length,
    primaryCandidates: primaryShortlistedApplicants.length,
    secondaryCandidates: secondaryShortlistedApplicants.length,
    applicants: filteredShortlistedApplicants.map(app => ({
      name: app.fullName,
      isPrimary: app.isPrimary,
      applicationId: app.applicationId
    }))
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  const handleSelectApplicant = (applicant: any) => {
    setSelectedApplicant(applicant.userId);
    // Call parent's onSelectApplicant function if provided
    if (onSelectApplicant) {
      onSelectApplicant(applicant.userId, applicant);
    }
  };

  const [selectedApplicant, setSelectedApplicant] = useState<number | null>(null);
  const [selectedCommentApplicant, setSelectedCommentApplicant] = useState<number | null>(null);

  const handleCommentClick = () => {
    if (isCommentView) {
      // If already in comment view, toggle back to normal view
      setIsCommentView(false);
    } else {
      // If in normal view, switch to comment view
      setIsCommentView(true);
      setSelectedCommentApplicant(0); // Select first shortlisted candidate by default
    }
    onCommentClick();
  };

  const handleCloseComment = () => {
    setIsCommentView(false);
  };

  const handleSelectCommentApplicant = (applicant: any) => {
    setSelectedCommentApplicant(applicant.userId);

    // Call parent's onSelectApplicant function if provided
    if (onSelectApplicant) {
      onSelectApplicant(applicant.userId, applicant);
    }
  };


  return (
    <Box >
      {/* Search and icon button - Conditionally visible */}
      {(!hideSearch || !hideComment || !hideShare || !hideRecommend) && (
        <Box display={"flex"} gap={1.5} width="100%">
          {!hideSearch && (
            <Box sx={{ flex: 1, width: "100%" }}>
              <TextField
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "38px",
                    fontSize: "13px",
                    border: "1.5px solid #B7B3EB",
                    borderRadius: "6px",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#B7B3EB",
                    opacity: "1",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <img
                        src="/images/search.svg"
                        width="17px"
                        height="17px"
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          )}
          {!hideComment && (
            <Tooltip title="Comment" arrow>
            <Box display={"flex"} gap={"2px"} onClick={handleCommentClick} style={{ cursor: "pointer" }}>
              <Badge 
                badgeContent={applicantsWithNewComments || 0} 
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: isCommentView ? "#756DE9" : "#FF8960",
                    color: "#fff",
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    transition: "background-color 0.2s ease",
                    fontSize: "12px",
                    fontWeight: "bold"
                  },
                }}
              >
                <IconButton
                  sx={{
                    // Toggle button behavior: filled when active, outlined when inactive
                    border: isCommentView ? "1.5px solid #756DE9" : "1.5px solid #B7B3EB",
                    borderRadius: "6px",
                    p: "4px",
                    height: "38px",
                    width: "38px",
                    backgroundColor: isCommentView ? "#756DE9" : "transparent",
                    color: isCommentView ? "#FFFFFF" : "#B7B3EB",
                    ":hover": {
                      backgroundColor: isCommentView ? "#6B5CE6" : "#E9EDF4",
                      borderColor: isCommentView ? "#6B5CE6" : "#756DE9"
                    },
                    transition: "all 0.2s ease",
                    "&:active": {
                      transform: "scale(0.98)"
                    }
                  }}
                >
                  <img
                    src="/images/comments.svg"
                    width="17px"
                    height="17px"
                    style={{
                      filter: isCommentView ? "brightness(0) invert(1)" : "brightness(0) saturate(100%) invert(72%) sepia(8%) saturate(1200%) hue-rotate(218deg) brightness(95%) contrast(85%)"
                    }}
                  ></img>
                </IconButton>
              </Badge>
            </Box>
            </Tooltip>
          )}
          {!hideShare && (
            <Tooltip 
              title={selectedCandidates && selectedCandidates.length > 0 ? "Share profile" : "Select profile to share"} 
              arrow
            >
            <Box>
              <IconButton
                  onClick={handleShareClick}
                sx={{
                  border: "1.5px solid #B7B3EB",
                  borderRadius: "6px",
                  p: "4px",
                  height: "38px",
                  width: "38px",
                  ":hover": { backgroundColor: "#E9EDF4" },
                }}
              >
                <img
                  src="/images/share.svg"
                  width="15px"
                  height="15px"
                ></img>
              </IconButton>
            </Box>
            </Tooltip>
          )}
          {!hideRecommend && onRecommendClick && (
            <Tooltip title="Recommend job" arrow>
              <Box>
                <IconButton
                  onClick={onRecommendClick}
                  sx={{
                    border: "1.5px solid #B7B3EB",
                    borderRadius: "6px",
                    p: "4px",
                    height: "38px",
                    width: "38px",
                    ":hover": { backgroundColor: "#E9EDF4" },
                  }}
                >
                  <ThumbUpOutlined
                    sx={{
                      fontSize: "20px",
                      color: "#756DE9",
                    }}
                  />
                </IconButton>
              </Box>
            </Tooltip>
          )}
        </Box>
      )}

      {/* Comment Header - Only show in comment view, positioned below search */}
      {isCommentView && (
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 0",
          borderBottom: "1px solid #E0E0E0",
          marginBottom: "16px"
        }}>
          <Typography sx={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#1F2235",
            fontFamily: "DM Sans"
          }}>
            Comment
          </Typography>
          <IconButton
            onClick={handleCloseComment}
            sx={{
              padding: "4px",
              "&:hover": { backgroundColor: "#F5F5F5" }
            }}
          >
            <img src="/images/close.svg" width="20px" height="20px" alt="Close" />
          </IconButton>
        </Box>
      )}

      {/* Applicants Tabs or Shared Profiles Header........... */}
      {!isCommentView && !showSharedProfiles && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#756DE9",
              height: "2px",
              borderRadius: "2px",
            },
            "& .MuiTab-root": {
              fontFamily: "DM Sans",
              fontSize: "14px",
              lineHeight: "17px",
              letterSpacing: "0.5%",
              fontWeight: 400,
              fontStyle: "normal",
              textTransform: "none",
              minHeight: "auto",
              padding: "12px 16px",
            },
            "& .Mui-selected": {
              fontWeight: 700,
              fontStyle: "normal",
              color: "#1F2235",
            },
          }}>
            <Tab label="Applied" {...a11yProps(0)} />
            <Tab label="Shortlisted" {...a11yProps(1)} />
          </Tabs>
        </Box>
      )}
      {!isCommentView && showSharedProfiles && (
        <Box sx={{ 
          padding: "16px 0",
          borderBottom: "1px solid #E0E0E0",
          marginBottom: "8px"
        }}>
          <Typography sx={{
            fontFamily: "DM Sans",
            fontSize: "18px",
            fontWeight: "600",
            color: "#1F2235",
          }}>
            {jobName ? `${jobName}` : "Shared Profiles"}
          </Typography>
        </Box>
      )}
      <Box sx={{
        maxHeight: 'calc(100vh - 250px)',
        overflowY: "auto",
        overflowX: "hidden",
        position: "sticky",
        top: 5,
        zIndex: 10,
        backgroundColor: "white",
        "&::-webkit-scrollbar": {
          width: "4px", // Thickness
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#f0f0f0", // very light grey
          borderRadius: "4px",
        },
      }}>

        {isCommentView && !showSharedProfiles ? (
          // Comment View - Show both sections
          <>
            {/* Shortlisted Section - Only show if there are shortlisted applicants */}
            {filteredShortlistedApplicants && filteredShortlistedApplicants.length > 0 && (
              <Box sx={{ marginBottom: "24px" }}>
                <Typography sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontStyle: "normal",
                  fontSize: "13px",
                  lineHeight: "17px",
                  letterSpacing: "0.5%",
                  color: "#1F2235",
                  marginBottom: "12px",
                }}>
                  Shortlisted
                </Typography>
                {filteredShortlistedApplicants.map((applicant, idx) => (
                  <React.Fragment key={applicant.userId}>
                    <Grid
                      container
                      wrap="nowrap"
                      onClick={() => handleSelectCommentApplicant(applicant)}
                      sx={{
                        bgcolor: selectedCommentApplicant === applicant.userId ? "#E6E4FE" : "#FFFFFF",
                        "&:hover": { bgcolor: "#E6E4FE" },
                        position: "relative",
                        width: "100%",
                        justifyContent: "space-between",
                        cursor: "pointer"
                      }}
                    >
                    <Box sx={{
                      width: '4px',
                      backgroundColor: selectedCommentApplicant === applicant.userId ? "#756DE9" : "transparent"
                    }}>
                    </Box>
                    <Grid
                      container
                      sx={{
                        px: 0.5,
                        py: 1.5,
                      }}
                    >
                      {/* Checkbox */}
                      <Grid item sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <Checkbox 
                          size="small" 
                          sx={{ 
                            p: 0, 
                            color: "#AAA7E4",
                            "&.Mui-checked": {
                              color: "#00C7BE",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: 20,
                            },
                          }} 
                          checked={isApplicantSelected(applicant)}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleCheckboxChange(applicant, e.target.checked);
                          }}
                        />
                        <Avatar
                          alt={applicant.fullName}
                          src={applicant.profilePicturePath || "/images/browse-jobs/applicant_profile.svg"}
                          sx={{ width: "36px", height: "36px" }}
                          variant="rounded"
                        />
                      </Grid>

                      {/* Name + Status */}
                      <Grid item xs sx={{ ml: 1, mr: 1 }}>
                        <Typography
                          fontSize="0.8rem"
                          fontWeight={600}
                          fontFamily={"DM Sans"}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          paddingTop={1}
                        >
                          {applicant.fullName}
                        </Typography>
                        {/* Status Chip */}
                        {applicant.isBestFit && (
                          <Chip
                            label="BEST FIT"
                            size="small"
                            sx={{
                              bgcolor: "#EDCD5A5E",
                              color: "#B56E00",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                        {applicant.applicationStatus === "DECLINED" && (
                          <Chip
                            label="DECLINED"
                            size="small"
                            sx={{
                              bgcolor: "#D1412A17",
                              color: "#D1412A",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                        {applicant.applicationStatus === "ACCEPTED" && (
                          <Chip
                            label="ACCEPTED"
                            size="small"
                            sx={{
                              bgcolor: "#4CAF5017",
                              color: "#4CAF50",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                        {applicant.applicationStatus === "SHORTLIST" && (
                          <Chip
                            label="SHORTLISTED"
                            size="small"
                            sx={{
                              bgcolor: "#2196F317",
                              color: "#2196F3",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>
                    
                    {/* Orange circle for new applicants - positioned at right end */}
                    {applicant.applicationId && (!applicant.viewedApplicants || !applicant.viewedApplicants.includes(applicant.applicationId)) && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          px: 1,
                        }}
                      >
                        <Box
                          sx={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: '#FF9800',
                            border: '1px solid #fff',
                            flexShrink: 0
                          }}
                        />
                      </Box>
                    )}
                  </Grid>

                  {/* Divider */}
                  {idx < (filteredShortlistedApplicants?.length || 0) - 1 && <Divider sx={{ bgcolor: "#cbc9e9ff", opacity: 0.5, height: "0.5px" }} />}
                  </React.Fragment>
                ))}
              </Box>
            )}

            {/* Applied Section - Only show if there are applied applicants */}
            {filteredAppliedApplicants && filteredAppliedApplicants.length > 0 && (
              <Box>
                <Typography sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontStyle: "normal",
                  fontSize: "13px",
                  lineHeight: "17px",
                  letterSpacing: "0.5%",
                  color: "#1F2235",
                  marginBottom: "12px",
                }}>
                  Applied
                </Typography>
                {filteredAppliedApplicants.slice(0, 4).map((applicant, idx) => (
                  <React.Fragment key={applicant.userId}>
                    <Grid
                      container
                      wrap="nowrap"
                      onClick={() => handleSelectCommentApplicant(applicant)}
                      sx={{
                        bgcolor: selectedCommentApplicant === applicant.userId ? "#E6E4FE" : "#FFFFFF",
                        "&:hover": { bgcolor: "#E6E4FE" },
                        position: "relative",
                        width: "100%",
                        justifyContent: "space-between",
                        cursor: "pointer"
                      }}
                    >
                    <Box sx={{
                      width: '4px',
                      backgroundColor: selectedCommentApplicant === applicant.userId ? "#756DE9" : "transparent"
                    }}>
                    </Box>
                    <Grid
                      container
                      sx={{
                        px: 0.5,
                        py: 1.5,
                      }}
                    >
                      {/* Checkbox */}
                      <Grid item sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <Checkbox 
                          size="small" 
                          sx={{ 
                            p: 0, 
                            color: "#AAA7E4",
                            "&.Mui-checked": {
                              color: "#00C7BE",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: 20,
                            },
                          }} 
                          checked={isApplicantSelected(applicant)}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleCheckboxChange(applicant, e.target.checked);
                          }}
                        />
                        <Avatar
                          alt={applicant.fullName}
                          src={applicant.profilePicturePath || "/images/browse-jobs/applicant_profile.svg"}
                          sx={{ width: "36px", height: "36px" }}
                          variant="rounded"
                        />
                      </Grid>

                      {/* Name + Status */}
                      <Grid item xs sx={{ ml: 1, mr: 1 }}>
                        <Typography
                          fontSize="0.8rem"
                          fontWeight={600}
                          fontFamily={"DM Sans"}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          paddingTop={1}
                        >
                          {applicant.fullName}
                          
                          {/* Orange circle for new applicants */}
                          {applicant.applicationId && (!applicant.viewedApplicants || !applicant.viewedApplicants.includes(applicant.applicationId)) && (
                            <Box
                              sx={{
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: '#FF9800',
                                border: '1px solid #fff',
                                flexShrink: 0
                              }}
                            />
                          )}
                        </Typography>

                        {/* Status Chip */}
                        {applicant.isBestFit && (
                          <Chip
                            label="BEST FIT"
                            size="small"
                            sx={{
                              bgcolor: "#EDCD5A5E",
                              color: "#B56E00",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                        {applicant.applicationStatus === "DECLINED" && (
                          <Chip
                            label="DECLINED"
                            size="small"
                            sx={{
                              bgcolor: "#D1412A17",
                              color: "#D1412A",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                        {applicant.applicationStatus === "ACCEPTED" && (
                          <Chip
                            label="ACCEPTED"
                            size="small"
                            sx={{
                              bgcolor: "#4CAF5017",
                              color: "#4CAF50",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                        {applicant.applicationStatus === "SHORTLIST" && (
                          <Chip
                            label="SHORTLISTED"
                            size="small"
                            sx={{
                              bgcolor: "#2196F317",
                              color: "#2196F3",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Divider */}
                  {idx < 3 && <Divider sx={{ bgcolor: "#cbc9e9ff", opacity: 0.5, height: "0.5px" }} />}
                  </React.Fragment>
                ))}
              </Box>
            )}
          </>
        ) : showSharedProfiles ? (
          // Shared Profiles View - Show all applicants
          <Box>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                <Typography>Loading applicants...</Typography>
              </Box>
            ) : allSharedProfiles && allSharedProfiles.length > 0 ? (
              allSharedProfiles.map((applicant, idx) => (
                <React.Fragment key={applicant.userId}>
                  <Grid
                    container
                    wrap="nowrap"
                    onClick={() => handleSelectApplicant(applicant)}
                    sx={{
                      bgcolor: (selectedApplicantId === applicant.applicationId || selectedApplicantId === applicant.userId) ? "#E6E4FE" : "#FFFFFF",
                      "&:hover": { bgcolor: "#E6E4FE" },
                      position: "relative",
                      width: "100%",
                      justifyContent: "space-between",
                      cursor: "pointer"
                    }}
                  >
                    <Box sx={{
                      width: '4px',
                      backgroundColor: selectedApplicant === applicant.userId ? "#756DE9" : "transparent"
                    }}></Box>
                    <Grid
                      container
                      sx={{
                        px: 0.5,
                        py: 1.5,
                      }}
                    >
                      {/* Avatar - No checkbox for shared profiles */}
                      <Grid item sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <Avatar
                          alt={applicant.fullName}
                          src={applicant.profilePicturePath || "/images/browse-jobs/applicant_profile.svg"}
                          sx={{ width: "36px", height: "36px" }}
                          variant="rounded"
                        />
                      </Grid>

                      {/* Name + Status */}
                      <Grid item xs sx={{ ml: 1, mr: 1 }}>
                        <Typography
                          fontSize="0.8rem"
                          fontWeight={600}
                          fontFamily={"DM Sans"}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          paddingTop={1}
                        >
                          {applicant.fullName}
                          
                          {/* Orange circle for new applicants */}
                          {applicant.isNew && (
                            <Box
                              sx={{
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: '#FF9800',
                                border: '1px solid #fff',
                                flexShrink: 0
                              }}
                            />
                          )}
                        </Typography>

                        {/* Status Chip */}
                        {applicant.isBestFit && (
                          <Chip
                            label="BEST FIT"
                            size="small"
                            sx={{
                              bgcolor: "#EDCD5A5E",
                              color: "#B56E00",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                        {applicant.applicationStatus === "DECLINED" && (
                          <Chip
                            label="DECLINED"
                            size="small"
                            sx={{
                              bgcolor: "#D1412A17",
                              color: "#D1412A",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                        {applicant.applicationStatus === "ACCEPTED" && (
                          <Chip
                            label="ACCEPTED"
                            size="small"
                            sx={{
                              bgcolor: "#4CAF5017",
                              color: "#4CAF50",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                        {applicant.applicationStatus === "SHORTLIST" && (
                          <Chip
                            label="SHORTLISTED"
                            size="small"
                            sx={{
                              bgcolor: "#2196F317",
                              color: "#2196F3",
                              fontWeight: 600,
                              fontSize: "0.7rem",
                              mt: 0.3,
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Divider */}
                  {idx < (allSharedProfiles?.length || 0) - 1 && <Divider sx={{ bgcolor: "#cbc9e9ff", opacity: 0.5, height: "0.5px" }} />}
                </React.Fragment>
              ))
            ) : (
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '60px 20px',
                textAlign: 'center'
              }}>
                <Box sx={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#f5f5f5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <img src="/images/comment_white.svg" width="32px" height="32px" alt="No profiles" style={{ opacity: 0.5 }} />
                </Box>
                <Typography sx={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#333',
                  marginBottom: '8px'
                }}>
                  No shared profiles
                </Typography>
                <Typography sx={{
                  fontSize: '14px',
                  color: '#666',
                  lineHeight: 1.5,
                  maxWidth: '280px'
                }}>
                  Shared profiles will appear here
                </Typography>
              </Box>
            )}
          </Box>
        ) : (
          // Normal View - Show tabs
          <>
            {/* Applied........... */}

            <CustomTabPanel value={value} index={0}>
              <Box >
                {loading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    <Typography>Loading applicants...</Typography>
                  </Box>
                ) : filteredAppliedApplicants && filteredAppliedApplicants.length > 0 ? (
                  filteredAppliedApplicants.map((applicant, idx) => (
                    <React.Fragment key={applicant.userId}>
                      <Grid
                        container
                        wrap="nowrap"
                        onClick={() => handleSelectApplicant(applicant)}
                        sx={{
                          bgcolor: (selectedApplicantId === applicant.applicationId || selectedApplicantId === applicant.userId) ? "#E6E4FE" : "#FFFFFF",
                          "&:hover": { bgcolor: "#E6E4FE" },
                          position: "relative",
                          width: "100%",
                          justifyContent: "space-between",
                          cursor: "pointer"
                        }}
                      >
                        <Box sx={{
                          width: '4px',
                          backgroundColor: selectedApplicant === applicant.userId ? "#756DE9" : "transparent"
                        }}>

                        </Box>
                        <Grid
                          container
                          sx={
                            {
                              px: 0.5,
                              py: 1.5,
                            }
                          }>
                          {/* Checkbox */}
                          <Grid item sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Checkbox 
                          size="small" 
                          sx={{ 
                            p: 0, 
                            color: "#AAA7E4",
                            "&.Mui-checked": {
                              color: "#00C7BE",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: 20,
                            },
                          }} 
                          checked={isApplicantSelected(applicant)}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleCheckboxChange(applicant, e.target.checked);
                          }}
                        />
                            <Avatar
                              alt={applicant.fullName}
                              src={applicant.profilePicturePath || "/images/browse-jobs/applicant_profile.svg"}
                              sx={{ width: "36px", height: "36px" }}
                              variant="rounded"
                            />
                          </Grid>

                          {/* Name + Status */}
                          <Grid item xs sx={{ ml: 1, mr: 1 }}>
                            <Typography
                              fontSize="0.8rem"
                              fontWeight={600}
                              fontFamily={"DM Sans"}
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              paddingTop={1}
                            >
                             {applicant.fullName}
                             
                             {/* Orange circle for new applicants */}
                             {applicant.isNew && (
                               <Box
                                 sx={{
                                   width: '8px',
                                   height: '8px',
                                   borderRadius: '50%',
                                   backgroundColor: '#FF9800',
                                   border: '1px solid #fff',
                                   flexShrink: 0
                                 }}
                               />
                             )}
                            </Typography>

                            {/* Status Chip */}
                            {applicant.isBestFit && (
                              <Chip
                                label="BEST FIT"
                                size="small"
                                sx={{
                                  bgcolor: "#EDCD5A5E",
                                  color: "#B56E00",
                                  fontWeight: 600,
                                  fontSize: "0.7rem",
                                  mt: 0.3,
                                }}
                              />
                            )}
                            {applicant.applicationStatus === "DECLINED" && (
                              <Chip
                                label="DECLINED"
                                size="small"
                                sx={{
                                  bgcolor: "#D1412A17",
                                  color: "#D1412A",
                                  fontWeight: 600,
                                  fontSize: "0.7rem",
                                  mt: 0.3,
                                }}
                              />
                            )}
                            {applicant.applicationStatus === "ACCEPTED" && (
                              <Chip
                                label="ACCEPTED"
                                size="small"
                                sx={{
                                  bgcolor: "#4CAF5017",
                                  color: "#4CAF50",
                                  fontWeight: 600,
                                  fontSize: "0.7rem",
                                  mt: 0.3,
                                }}
                              />
                            )}
                            {applicant.applicationStatus === "SHORTLIST" && (
                              <Chip
                                label="SHORTLISTED"
                                size="small"
                                sx={{
                                  bgcolor: "#2196F317",
                                  color: "#2196F3",
                                  fontWeight: 600,
                                  fontSize: "0.7rem",
                                  mt: 0.3,
                                }}
                              />
                            )}
                          </Grid>
                        </Grid>
                      </Grid>


                      {/* Divider */}
                      {idx < (filteredAppliedApplicants?.length || 0) - 1 && <Divider sx={{ bgcolor: "#cbc9e9ff", opacity: 0.5, height: "0.5px" }} />}
                    </React.Fragment>
                  ))
                ) : (
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '60px 20px',
                    textAlign: 'center'
                  }}>
                    <Box sx={{
                      width: '80px',
                      height: '80px',
                      borderRadius: '50%',
                      backgroundColor: '#f5f5f5',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '20px'
                    }}>
                      <img src="/images/comment_white.svg" width="32px" height="32px" alt="No applicants" style={{ opacity: 0.5 }} />
                    </Box>
                    <Typography sx={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#333',
                      marginBottom: '8px'
                    }}>
                      No applied candidates
                    </Typography>
                    <Typography sx={{
                      fontSize: '14px',
                      color: '#666',
                      lineHeight: 1.5,
                      maxWidth: '280px'
                    }}>
                      Applied candidates will appear here once they submit their applications for this job
                    </Typography>
                  </Box>
                )}
              </Box>
            </CustomTabPanel>
            {/* shortlisted.......... */}

            <CustomTabPanel value={value} index={1}>
              <Box >
                {loading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    <Typography>Loading applicants...</Typography>
                  </Box>
                ) : filteredShortlistedApplicants && filteredShortlistedApplicants.length > 0 ? (
                  <>
                    {/* Primary Candidates Section */}
                    {primaryShortlistedApplicants.length > 0 && (
                      <Box sx={{ marginBottom: "24px" }}>
                        <Typography sx={{
                          fontFamily: "DM Sans",
                          fontWeight: 400,
                          fontStyle: "normal",
                          fontSize: "13px",
                          lineHeight: "17px",
                          letterSpacing: "0.5%",
                          color: "#1F2235",
                          marginBottom: "12px",
                        }}>
                          Primary Candidate List
                        </Typography>
                        {primaryShortlistedApplicants.map((applicant, idx) => (
                          <React.Fragment key={applicant.userId}>
                            <Grid
                              container
                              wrap="nowrap"
                              onClick={() => handleSelectApplicant(applicant)}
                              sx={{
                                bgcolor: (selectedApplicantId === applicant.applicationId || selectedApplicantId === applicant.userId) ? "#E6E4FE" : "#FFFFFF",
                                "&:hover": { bgcolor: "#E6E4FE" },
                                position: "relative",
                                width: "100%",
                                justifyContent: "space-between",
                                cursor: "pointer"
                              }}
                            >
                              <Box sx={{
                                width: '4px',
                                backgroundColor: selectedApplicant === applicant.userId ? "#756DE9" : "transparent"
                              }}>

                              </Box>
                            <Grid
                              container
                              sx={
                                {
                                  px: 0.5,
                                  py: 1.5,
                                }
                              }>
                              {/* Checkbox */}
                              <Grid item sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                <Checkbox 
                                size="small" 
                                sx={{ 
                                  p: 0, 
                                  color: "#AAA7E4",
                                  "&.Mui-checked": {
                                    color: "#00C7BE",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 20,
                                  },
                                }} 
                                checked={isApplicantSelected(applicant)}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  handleCheckboxChange(applicant, e.target.checked);
                                }}
                              />
                                <Box sx={{ position: "relative" }}>
                                  <Avatar
                                    alt={applicant.fullName}
                                    src={applicant.profilePicturePath || "/images/browse-jobs/applicant_profile.svg"}
                                    sx={{ width: "36px", height: "36px" }}
                                    variant="rounded"
                                  />
                                  {/* New applicant indicator */}
                                  {/* {applicant.isNew && (
                                    <Box
                                      sx={{
                                        position: "absolute",
                                        top: "-2px",
                                        right: "-2px",
                                        width: "12px",
                                        height: "12px",
                                        borderRadius: "50%",
                                        backgroundColor: "#FF98FF",
                                        border: "2px solid white",
                                        zIndex: 1
                                      }}
                                    />
                                  )} */}
                                </Box>
                              </Grid>

                              {/* Name + Status */}
                              <Grid item xs sx={{ ml: 1, mr: 1 }}>
                                <Typography
                                  fontSize="0.8rem"
                                  fontWeight={600}
                                  fontFamily={"DM Sans"}
                                  display="flex"
                                  alignItems="center"
                                  color={"#000105"}
                                  justifyContent="space-between"
                                  paddingTop={1}
                                >
                                  {applicant.fullName}
                                </Typography>

                                {/* Status Chip */}
                                {applicant.isBestFit && (
                                  <Chip
                                    label="BEST FIT"
                                    size="small"
                                    sx={{
                                      bgcolor: "#EDCD5A5E",
                                      color: "#B56E00",
                                      fontWeight: 600,
                                      fontSize: "0.7rem",
                                      mt: 0.3,
                                    }}
                                  />
                                )}
                                {applicant.applicationStatus === "DECLINED" && (
                                  <Chip
                                    label="DECLINED"
                                    size="small"
                                    sx={{
                                      bgcolor: "#D1412A17",
                                      color: "#D1412A",
                                      fontWeight: 600,
                                      fontSize: "0.7rem",
                                      mt: 0.3,
                                    }}
                                  />
                                )}
                                {applicant.applicationStatus === "ACCEPTED" && (
                                  <Chip
                                    label="ACCEPTED"
                                    size="small"
                                    sx={{
                                      bgcolor: "#4CAF5017",
                                      color: "#4CAF50",
                                      fontWeight: 600,
                                      fontSize: "0.7rem",
                                      mt: 0.3,
                                    }}
                                  />
                                )}
                                {applicant.applicationStatus === "SHORTLIST" && (
                                  <Chip
                                    label="SHORTLISTED"
                                    size="small"
                                    sx={{
                                      bgcolor: "#2196F317",
                                      color: "#2196F3",
                                      fontWeight: 600,
                                      fontSize: "0.7rem",
                                      mt: 0.3,
                                    }}
                                  />
                                )}
                                
                              </Grid>
                            </Grid>
                            
                            {/* Orange circle for new applicants - positioned at right end */}
                            {applicant.isNew && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  px: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: '#FF9800',
                                    border: '1px solid #fff',
                                    flexShrink: 0
                                  }}
                                />
                              </Box>
                            )}
                          </Grid>

                            {/* Divider */}
                            {idx < primaryShortlistedApplicants.length - 1 && <Divider sx={{ bgcolor: "#cbc9e9ff", opacity: 0.5, height: "0.5px" }} />}
                          </React.Fragment>
                        ))}
                      </Box>
                    )}

                    {/* Secondary Candidates Section */}
                    {secondaryShortlistedApplicants.length > 0 && (
                      <Box sx={{ marginBottom: "24px" }}>
                        <Typography sx={{
                          fontFamily: "DM Sans",
                          fontWeight: 400,
                          fontStyle: "normal",
                          fontSize: "13px",
                          lineHeight: "17px",
                          letterSpacing: "0.5%",
                          color: "#1F2235",
                          marginBottom: "12px",
                        }}>
                          Secondary Candidate List
                        </Typography>
                        {secondaryShortlistedApplicants.map((applicant, idx) => (
                          <React.Fragment key={applicant.userId}>
                            <Grid
                              container
                              wrap="nowrap"
                              onClick={() => handleSelectApplicant(applicant)}
                              sx={{
                                bgcolor: (selectedApplicantId === applicant.applicationId || selectedApplicantId === applicant.userId) ? "#E6E4FE" : "#FFFFFF",
                                "&:hover": { bgcolor: "#E6E4FE" },
                                position: "relative",
                                width: "100%",
                                justifyContent: "space-between",
                                cursor: "pointer"
                              }}
                            >
                              <Box sx={{
                                width: '4px',
                                backgroundColor: selectedApplicant === applicant.userId ? "#756DE9" : "transparent"
                              }}>

                              </Box>
                            <Grid
                              container
                              sx={
                                {
                                  px: 0.5,
                                  py: 1.5,
                                }
                              }>
                              {/* Checkbox */}
                              <Grid item sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                <Checkbox 
                                size="small" 
                                sx={{ 
                                  p: 0, 
                                  color: "#AAA7E4",
                                  "&.Mui-checked": {
                                    color: "#00C7BE",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 20,
                                  },
                                }} 
                                checked={isApplicantSelected(applicant)}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  handleCheckboxChange(applicant, e.target.checked);
                                }}
                              />
                                <Box sx={{ position: "relative" }}>
                                  <Avatar
                                    alt={applicant.fullName}
                                    src={applicant.profilePicturePath || "/images/browse-jobs/applicant_profile.svg"}
                                    sx={{ width: "36px", height: "36px" }}
                                    variant="rounded"
                                  />
                                  {/* New applicant indicator */}
                                  {/* {applicant.isNew && (
                                    <Box
                                      sx={{
                                        position: "absolute",
                                        top: "-2px",
                                        right: "-2px",
                                        width: "12px",
                                        height: "12px",
                                        borderRadius: "50%",
                                        backgroundColor: "#FF9800",
                                        border: "2px solid white",
                                        zIndex: 1
                                      }}
                                    />
                                  )} */}
                                </Box>
                              </Grid>

                              {/* Name + Status */}
                              <Grid item xs sx={{ ml: 1, mr: 1 }}>
                                <Typography
                                  fontSize="0.8rem"
                                  fontWeight={600}
                                  fontFamily={"DM Sans"}
                                  display="flex"
                                  alignItems="center"
                                  color={"#000105"}
                                  justifyContent="space-between"
                                  paddingTop={1}
                                >
                                  {applicant.fullName}
                                </Typography>

                                {/* Status Chip */}
                                {applicant.isBestFit && (
                                  <Chip
                                    label="BEST FIT"
                                    size="small"
                                    sx={{
                                      bgcolor: "#EDCD5A5E",
                                      color: "#B56E00",
                                      fontWeight: 600,
                                      fontSize: "0.7rem",
                                      mt: 0.3,
                                    }}
                                  />
                                )}

                                {applicant.applicationStatus === "DECLINED" && (
                                  <Chip
                                    label="DECLINED"
                                    size="small"
                                    sx={{
                                      bgcolor: "#D1412A17",
                                      color: "#D1412A",
                                      fontWeight: 600,
                                      fontSize: "0.7rem",
                                      mt: 0.3,
                                    }}
                                  />
                                )}
                                {applicant.applicationStatus === "ACCEPTED" && (
                                  <Chip
                                    label="ACCEPTED"
                                    size="small"
                                    sx={{
                                      bgcolor: "#4CAF5017",
                                      color: "#4CAF50",
                                      fontWeight: 600,
                                      fontSize: "0.7rem",
                                      mt: 0.3,
                                    }}
                                  />
                                )}
                                {applicant.applicationStatus === "SHORTLIST" && (
                                  <Chip
                                    label="SHORTLISTED"
                                    size="small"
                                    sx={{
                                      bgcolor: "#2196F317",
                                      color: "#2196F3",
                                      fontWeight: 600,
                                      fontSize: "0.7rem",
                                      mt: 0.3,
                                    }}
                                  />
                                )}
                              </Grid>
                            </Grid>
                            
                            {/* Orange circle for new applicants - positioned at right end */}
                            {applicant.isNew && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  px: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: '#FF9800',
                                    border: '1px solid #fff',
                                    flexShrink: 0
                                  }}
                                />
                              </Box>
                            )}
                          </Grid>

                            {/* Divider */}
                            {idx < secondaryShortlistedApplicants.length - 1 && <Divider sx={{ bgcolor: "#cbc9e9ff", opacity: 0.5, height: "0.5px" }} />}
                          </React.Fragment>
                        ))}
                      </Box>
                    )}
                  </>
                ) : (
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '60px 20px',
                    textAlign: 'center'
                  }}>
                    <Box sx={{
                      width: '80px',
                      height: '80px',
                      borderRadius: '50%',
                      backgroundColor: '#f5f5f5',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '20px'
                    }}>
                      <img src="/images/comment_white.svg" width="32px" height="32px" alt="No shortlisted" style={{ opacity: 0.5 }} />
                    </Box>
                    <Typography sx={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#333',
                      marginBottom: '8px'
                    }}>
                      No shortlisted candidates
                    </Typography>
                    <Typography sx={{
                      fontSize: '14px',
                      color: '#666',
                      lineHeight: 1.5,
                      maxWidth: '280px'
                    }}>
                      Shortlisted candidates will appear here once you mark them as shortlisted
                    </Typography>
                  </Box>
                )}
              </Box>
            </CustomTabPanel>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Applicants;